/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [
  vp.InboundETransferTransactionResponse,
  (requestParams: vp.InboundETransferTransactionRequest) => void,
  () => void,
];

function useFetchInboundETransferTransaction({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [params, setParams] = useState<vp.InboundETransferTransactionRequest>();
  const [response, setResponse] = useState<vp.InboundETransferTransactionResponse>({
    ErrorMessage: '',
    Success: false,
    Transactions: {
      Amount: '',
      DateReceived: '',
      Email: '',
      ID: '',
      Message: '',
      MessageID: '',
      Name: '',
      Status: '',
    },
  });
  const [shouldSendRequest, setSendRequest] = useState(false);

  useEffect(() => {
    const sendRequest = async (requestParams: vp.InboundETransferTransactionRequest) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen', true);
      const res = await api.fetchInboundETransferTransaction(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false, 'loading some data', 'fullScreen', false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.InboundETransferTransactionRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setSendRequest(false);
      setParams(undefined);
      setResponse({
        ErrorMessage: '',
        Success: false,
        Transactions: {
          Amount: '',
          DateReceived: '',
          Email: '',
          ID: '',
          Message: '',
          MessageID: '',
          Name: '',
          Status: '',
        },
      });
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchInboundETransferTransaction);
